import { mount } from 'enzyme';
import * as React from 'react';

import { ToolTipDataComponent } from './tooltipdata';

describe('ToolTip Data', () => {
  let averageReturn = 4000;
  let averageReturnPercent = 4;
  let gainPercent = 4;
  let lossPercent = 0;

  test('should match snapshot and styles for default props', () => {
    expect(
      mount(
        <ToolTipDataComponent
          averageReturn={averageReturn}
          averageReturnPercent={averageReturnPercent}
          gainPercent={gainPercent}
          lossPercent={lossPercent}
        />,
      ),
    ).toMatchSnapshot();
  });
});
